require( 'intersection-observer' );

export default class TeaserSmall {
  constructor( node ) {
    this.node = node;
    this.handleButton();

    window.addEventListener( 'load', () => {
      this.createIntersectionObserver();
    });
  }

  /**
   * if container is clicked => trigger button inside
   */

  handleButton() {
    this.node.addEventListener( 'click', () => {
      this.node.querySelector( '.button' ).click();
    });
  }

  handleIntersectionObserver( entries, observer ) {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        entry.target.classList.add( 'teaser-big--fade-in' );
        observer.unobserve( entry.target );
      }
    });
  }

  createIntersectionObserver() {
    let observer;
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25
    };

    observer = new IntersectionObserver( this.handleIntersectionObserver, options );
    observer.observe( this.node );
  }
}
